<div class="collaboration-container">

    <!-- Notes list (maps to PSD "Internal Comments") -->
    <div class="comments-list" *ngIf="notes.length > 0">
        <div class="comment-row" *ngFor="let note of notes">
            <div class="comment-avatar">
                <img *ngIf="getAuthorPicture(note.author)" [src]="getAuthorPicture(note.author)" alt="">
                <span *ngIf="!getAuthorPicture(note.author)" class="avatar-initials">{{ getAuthorInitials(note.author) }}</span>
            </div>
            <div class="comment-content">
                <div class="comment-header">
                    <span class="comment-author">{{ getAuthorName(note.author) }}</span>
                    <span class="comment-date">
                        {{ getRelativeTime(note.createdAt) }}
                        <span class="edited-tag" *ngIf="note.edited">&nbsp;({{ 'permit.manage.collaboration.edited' | translate }})</span>
                    </span>
                    <button
                        type="button"
                        class="edit-button"
                        *ngIf="editingNoteId !== note._id"
                        (click)="startEdit(note)"
                        [attr.aria-label]="'permit.manage.collaboration.edit' | translate">
                        <mat-icon>edit</mat-icon>
                    </button>
                </div>

                <!-- Read mode -->
                <div
                    class="comment-text"
                    *ngIf="editingNoteId !== note._id"
                    [innerHTML]="note.text | permitRenderMentions:currentLang"
                    (click)="onMentionClick($event)"
                    (keydown.enter)="onMentionClick($event)">
                </div>

                <!-- Edit mode -->
                <div class="note-edit" *ngIf="editingNoteId === note._id">
                    <div class="edit-input-wrapper">
                        <div class="textarea-highlight-wrapper textarea-highlight-wrapper--boxed">
                            <div class="mention-highlight-overlay" #editOverlay aria-hidden="true" [innerHTML]="highlightMentions(editText)"></div>
                            <textarea
                                class="note-textarea"
                                [(ngModel)]="editText"
                                rows="2"
                                (input)="onEditInput($event)"
                                (scroll)="onTextareaScroll($event, editOverlay)"
                                (blur)="onTextareaBlur()">
                            </textarea>
                        </div>

                        <div class="mention-dropdown" *ngIf="showMentionDropdown && mentionTarget === 'edit'">
                            <div class="mention-loading" *ngIf="mentionLoading">
                                <mat-spinner [diameter]="16"></mat-spinner>
                            </div>
                            <ng-container *ngIf="!mentionLoading">
                                <button
                                    type="button"
                                    class="mention-item"
                                    *ngFor="let admin of mentionSearchResults"
                                    (mousedown)="$event.preventDefault()"
                                    (click)="selectMention(admin)">
                                    <div class="mention-avatar">
                                        <img *ngIf="admin.picture" [src]="admin.picture" alt="">
                                        <div *ngIf="!admin.picture" class="mention-initials">{{ admin.initials }}</div>
                                    </div>
                                    <div class="mention-info">
                                        <span class="mention-name">{{ admin.name }}</span>
                                        <span class="mention-email">{{ admin.email }}</span>
                                    </div>
                                </button>
                                <div class="mention-no-results" *ngIf="mentionSearchResults.length === 0">
                                    {{ 'permit.manage.collaboration.mention_no_results' | translate }}
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    <div class="note-edit-actions">
                        <button type="button" class="icon-btn cancel-btn" (click)="cancelEdit()" [disabled]="isSavingEdit">
                            <mat-icon>close</mat-icon>
                        </button>
                        <button
                            type="button"
                            class="icon-btn save-btn"
                            [disabled]="!editText.trim() || isSavingEdit"
                            (click)="saveEdit(note)">
                            <mat-icon *ngIf="!isSavingEdit">check</mat-icon>
                            <mat-spinner *ngIf="isSavingEdit" [diameter]="14"></mat-spinner>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Add note input -->
    <div class="new-note-section">
        <div class="input-pill">
            <div class="textarea-highlight-wrapper">
                <div class="mention-highlight-overlay" #newOverlay aria-hidden="true" [innerHTML]="highlightMentions(newNoteText)"></div>
                <textarea
                    class="comment-textarea"
                    [(ngModel)]="newNoteText"
                    [placeholder]="'permit.manage.collaboration.note_placeholder' | translate"
                    rows="1"
                    (input)="onNoteInput($event)"
                    (scroll)="onTextareaScroll($event, newOverlay)"
                    (blur)="onTextareaBlur()"
                    (keydown.enter)="onNoteEnter($event)">
                </textarea>
            </div>
            <button
                type="button"
                class="send-button"
                [disabled]="!newNoteText.trim() || isAdding"
                (click)="addNote()">
                <mat-icon *ngIf="!isAdding">send</mat-icon>
                <mat-spinner *ngIf="isAdding" [diameter]="16"></mat-spinner>
            </button>
        </div>

        <div class="mention-dropdown" *ngIf="showMentionDropdown && mentionTarget === 'new'">
            <div class="mention-loading" *ngIf="mentionLoading">
                <mat-spinner [diameter]="16"></mat-spinner>
            </div>
            <ng-container *ngIf="!mentionLoading">
                <button
                    type="button"
                    class="mention-item"
                    *ngFor="let admin of mentionSearchResults"
                    (mousedown)="$event.preventDefault()"
                    (click)="selectMention(admin)">
                    <div class="mention-avatar">
                        <img *ngIf="admin.picture" [src]="admin.picture" alt="">
                        <div *ngIf="!admin.picture" class="mention-initials">{{ admin.initials }}</div>
                    </div>
                    <div class="mention-info">
                        <span class="mention-name">{{ admin.name }}</span>
                        <span class="mention-email">{{ admin.email }}</span>
                    </div>
                </button>
                <div class="mention-no-results" *ngIf="mentionSearchResults.length === 0">
                    {{ 'permit.manage.collaboration.mention_no_results' | translate }}
                </div>
            </ng-container>
        </div>
    </div>

</div>
